<template>
  <el-dialog :visible.sync="showDialog" width="870px" :append-to-body="true" :close-on-click-modal="false" v-dialogDrag
    v-loading="btnSubmit">
    <div slot="title" class="current-disease">
      <span>{{ title }}</span>
    </div>
    <div>
      <div class="dialog-main">
        <el-form :model="formData" label-position="top" :rules="rules" label-width="100px" ref="formRef">
          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="姓名" prop="patientName">
                <el-input v-model="formData.patientName" placeholder="请输入" size="small">
                  <img slot="suffix" src="~@/assets/images/id-card.png" class="input-img" alt="" />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号" prop="patientPhone">
                <el-input v-model="formData.patientPhone" placeholder="请输入" size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别" prop="patientGender">
                <el-select v-model="formData.patientGender" placeholder="请选择">
                  <el-option label="男" :value="1"></el-option>
                  <el-option label="女" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="16">
              <el-form-item label="身份证" prop="idNumber">
                <el-input v-model="formData.idNumber" placeholder="请输入" size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出生日期" prop="patientBirthday">
                <el-date-picker v-model="formData.patientBirthday" type="date" placeholder="选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="身高" prop="height">
                <el-input v-model.number.trim="formData.height" min="0" type="number" placeholder="请输入" size="small">
                  <template slot="append">cm</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="体重" prop="weight">
                <el-input v-model.number.trim="formData.weight" min="0" type="number" placeholder="请输入" size="small">
                  <template slot="append">kg</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年龄" prop="patientAge">
                <template v-if="formData.patientBirthday">
                  <el-tooltip content="若填写出生日期，此项不可更改" placement="top-end" effect="light">
                    <el-input v-model.number.trim="formData.patientAge" min="0" type="number" placeholder="请输入"
                      size="small" disabled />
                  </el-tooltip>
                </template>
                <el-input v-else v-model.number.trim="formData.patientAge" min="0" type="number" placeholder="请输入"
                  size="small">
                  <template slot="append">岁</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="就诊卡" prop="medicalCardNumber">
            <el-input v-model="formData.medicalCardNumber" placeholder="请输入" size="small" />
          </el-form-item>
          <el-form-item label="地址" prop="userAddress">
            <el-input v-model="formData.userAddress" placeholder="请输入" size="small" />
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-wrap">
        <div @click="cancel">取 消</div>
        <div @click="confirm">确 定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import { addPatient, beforeAddPatient } from '@/api/business/doctor/member-manager'

export default {
  name: 'AddPatientDialog',
  data() {
    return {
      showDialog: false,
      submitLoading: false,
      btnSubmit: false,
      title: '',
      formData: {
        patientCode: '',
        patientName: '',
        height: null,
        idNumber: '',
        medicalCardNumber: '',
        patientAge: null,
        patientBirthday: '',
        patientGender: 0,
        patientPhone: '',
        userAddress: '',
        weight: null
      },
      pickerOptions: {
        disabledDate(time) {
          // 禁用未来日期（包括今天之后）
          return time.getTime() > Date.now()
        }
      },
      rules: {
        patientName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        idNumber: [{
          validator: (rule, value, callback) => {
            if (value && !/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)) {
              callback(new Error('身份证号格式错误'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        patientPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value || value.length !== 11) {
                callback(new Error('手机号格式错误'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    'formData.patientBirthday'(val) {
      if (val) {
        this.calculateAgeByBirthday(val)
      }
    }
  },
  methods: {
    cancel() {
      this.formData = {}
      this.showDialog = false
      this.$refs.formRef.resetFields()
    },
    open(data) {
      this.showDialog = true
      this.formData = {}
      if (data !== null && data.patientCode) {
        this.formData = { ...data }
        if (this.formData.height === 0) {
          this.formData.height = null
        }
        if (this.formData.weight === 0) {
          this.formData.weight = null
        }
        if (this.formData.patientAge === 0) {
          this.formData.patientAge = null
        }
        this.title = '编辑患者'
      } else if (data !== null) {
        this.formData = { ...data }
        if (this.formData.height === 0) {
          this.formData.height = null
        }
        if (this.formData.weight === 0) {
          this.formData.weight = null
        }
        if (this.formData.patientAge === 0) {
          this.formData.patientAge = null
        }
        this.title = '新增患者'
      } else {
        this.title = '新增患者'
      }
    },
    confirm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let form = {
            patientName: this.formData.patientName,
            height: this.formData.height,
            idNumber: this.formData.idNumber,
            medicalCardNumber: this.formData.medicalCardNumber,
            patientAge: this.formData.patientAge,
            patientBirthday: this.formData.patientBirthday,
            patientGender: this.formData.patientGender,
            patientPhone: this.formData.patientPhone,
            totalAmount: 0,
            userAddress: this.formData.userAddress,
            weight: this.formData.weight
          }
          // 编辑
          if (this.formData.id && this.formData.patientCode) {
            form = {
              ...form,
              id: this.formData.id,
              patientCode: this.formData.patientCode
            }
            this.$confirm('请确认该操作', '请确认', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.btnSubmit = true
              addPatient(form).then(({ data }) => {
                if (data && data.code === 0) {
                  this.formData.patientCode = data.data
                  this.$message.success('患者档案保存成功！')
                  this.showDialog = false
                  this.$emit('selectNew', this.formData)
                  this.$emit('refresh')
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消保存'
              })
            }).finally(() => {
              this.btnSubmit = false
            })
          } else {
            // 新增
            // 如果姓名和手机号都重复，则需要确认后添加
            beforeAddPatient(form).then(({ data }) => {
              if (data && data.code === 0) {
                if (data.data === 0) {
                  // 不存在
                  addPatient(form).then(({ data }) => {
                    if (data && data.code === 0) {
                      this.formData.patientCode = data.data
                      this.$message.success('患者档案保存成功！')
                      this.showDialog = false
                      this.$emit('selectNew', this.formData)
                      this.$emit('refresh')
                    }
                  })
                } else {
                  // 已存在，需要确认
                  this.$confirm('已存在同名同手机号患者，请确认后添加！', '请确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    addPatient(form).then(({ data }) => {
                      if (data && data.code === 0) {
                        this.formData.patientCode = data.data
                        this.$message.success('患者档案保存成功！')
                        this.showDialog = false
                        this.$emit('selectNew', this.formData)
                        this.$emit('refresh')
                      }
                    })
                  }).catch(() => {
                    this.$message({
                      type: 'info',
                      message: '已取消保存'
                    })
                  })
                }
              }
            }).finally(() => {
              this.btnSubmit = false
            })
          }
        }
      })
    },
    calculateAgeByBirthday(birth) {
      const birthYear = parseInt(birth.substring(0, 4))
      const birthMonth = parseInt(birth.substring(5, 7))
      const birthDay = parseInt(birth.substring(8, 10))

      const today = new Date()
      const currentYear = today.getFullYear()
      const currentMonth = today.getMonth() + 1
      const currentDay = today.getDate()

      let age = currentYear - birthYear

      if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
        age-- // 还未过生日，年龄减一
      }
      this.formData.patientAge = age
    }
  }
}
</script>

<style scoped lang="scss">
.current-disease {
  font-size: 26px;
  margin-top: 12px;
  color: #333333;
  text-align: center;
  line-height: 37px;
  font-weight: 600;

}

.btn-wrap {
  width: 100%;
  padding: 20px 30px;
  display: flex;
  justify-content: center;
  gap: 40px;

  div {
    flex: 1;
    border: 1px solid #3F7AFF;
    height: 50px;
    line-height: 50px;
    background-color: #eaf0ff;
    border-radius: 8px;
    text-align: center;
    font-size: 16px;
    color: #3F7AFF;
    cursor: pointer;
    max-width: 50%;
  }

  div:last-child {
    background: linear-gradient(90deg, #3F7AFF 0%, #6B93E8 100%);
    color: #ffffff;
  }
}

/deep/ .el-dialog {
  background: linear-gradient(180deg, #B2D0FF 0%, #FDFEFF 20%, #FFFFFF 100%);
  border-radius: 14px;
  padding: 0 45px;
}

/deep/ .el-input__inner {
  height: 55px !important;
  line-height: 55px !important;
  background: rgba(244, 248, 255, 0.39);
  border-radius: 10px;
  border: 1px solid rgba(63, 122, 255, 0.349);
  font-size: 18px;
  padding-right: 0;

}

/deep/ .el-form-item__label {
  height: 25px;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
}

/deep/ .el-input-group>.el-input__inner {
  border-top-right-radius: 0%;
  border-bottom-right-radius: 0%;
  border-right: 0;

}

/deep/ .el-input-group__append {
  border: 1px solid rgba(63, 122, 255, 0.349);
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.input-img {
  width: 30px;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/doctor2/manage/patient/components/base/add-patient-dialog.vue